package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.system.MetadataDto
import com.evoapps.evoshift.domain.model.AuditMetadata

class MetadataMapper {

    fun toDomain(dto: MetadataDto): AuditMetadata {
        return AuditMetadata(
            createdAt = dto.createdAt,
            createdBy = dto.createdBy,
            updatedAt = dto.updatedAt,
            updatedBy = dto.updatedBy
        )
    }

    fun toDto(domain: AuditMetadata): MetadataDto {
        return MetadataDto(
            createdAt = domain.createdAt,
            createdBy = domain.createdBy,
            updatedAt = domain.updatedAt,
            updatedBy = domain.updatedBy
        )
    }
}
